<template>
  <div class="purchase-intro">
    <section-header tag="h1" class="mt-5 mb-5" title="購物說明" subtitle="Purchase Intro"/>
    <section>
      <p>為確保您在 Loft29 Collection 購物網站上的購物品質,首先必須請您先加入網站會員才能進行線上購物。加入我們的會員不但完全免費,簡單方便的註冊流程引導您完成填寫後,即可享受會員獨享購物優惠及完整的購物服務;同時,我們也將嚴密確保您的會員資料隱私,您的個人資料及購物資料不會使用在其他用途上,請您安心享受購物樂趣。</p>
      <p>請務必詳讀以下購物說明</p>
    </section>
    <section class="mt-5">
      <collapse-item v-for="(item, index) in context" :id="item.id" :title="item.title" :content="item.content" :key="index">
        <component v-if="item.component" :is="item.component"/>
      </collapse-item>
      <div class="border-top border-dark"></div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
import CollapseItem from '@/components/CollapseItem.vue'
import PaymentInfo from '@/components/Info/PaymentInfo.vue'
import DeliveryInfo from '@/components/Info/DeliveryInfo.vue'
import ReturnInfo from '@/components/Info/ReturnInfo.vue'

export default {
  name: 'PurchaseIntro',
  components: {
    SectionHeader,
    CollapseItem
  },
  data: function () {
    return {
      context: [
        {
          id: 'purchase',
          title: '訂購方式',
          content: [
            '<div class="mb-2">目前在Loft29 Collection的訂購方式可利用網路及電話兩種方式</div>',
            '<b>網路訂購</b>:您可以在加入網站會員後,依照網頁上的簡易引導完成購物流程。',
            '<b>電話訂購</b>:您可以於上班時間直接來電(02)8771-3329,我們將有專員為您服務。'
          ]
        },
        {
          id: 'payment',
          title: '付款方式與交易安全',
          content: [
            '在Loft29 Collection購物網站中現貨商品及單件未滿 2 萬元期貨商品需於訂購時付清全額款項;單件 2 萬元以上期貨商品需於訂購時預付 50% 訂金,商品到貨時我們會再與您確認訂單餘額,您可以線上刷卡或ATM轉帳/臨櫃匯款方式付清餘額,我們會在確認收到您的餘額款項後將盡速為您辦理出貨。 您可選擇以下付款方式:'
          ],
          component: PaymentInfo
        },
        {
          id: 'member',
          title: '會員累計優惠制度',
          content: [
            '<div class="mb-2">Loft29 Collection網站會員於註冊後的每筆訂單將自動儲存於您的訂單紀錄中,您可以隨時登入『會員專區』中查詢您的購物紀錄及累積消費折扣:</div>',
            '累計消費金額達NT$100,000元以上,可享往後購物95折優惠折扣。',
            '累計消費金額達NT$400,000元以上,可享往後購物 9折優惠折扣。',
            '累計消費金額達NT$1,000,000元以上,可享往後購物 85折優惠折扣。',
            '<div class="mt-2 loft-text-highlight">特殊運費/施工費用、部分折扣商品及活動商品恕不另行折扣,Loft29 Collection 保留更動會員相關制度之權利。</div>'
          ]
        },
        {
          id: 'delivery',
          title: '商品配送流程與運費',
          content: [
            '配送流程:',
            '確認全額款項 -> 確認收貨資料 -> 郵局/物流公司遞送 -> 確認商品已送達'
          ],
          component: DeliveryInfo
        },
        {
          id: 'return',
          title: '缺貨與退換貨說明',
          content: [
            '本公司販售之商品皆享有原廠商之基本保固及維護說明。'
          ],
          component: ReturnInfo
        },
        {
          id: 'service',
          title: '產品申訴及處理服務',
          content: [
            '<div class="mb-2">若客戶有關產品瑕疵部分有任何意見或疑問時,可以採用下列方式處理</div>',
            '服務電話:(02) 8771-3329',
            '電子郵件:info@loft29.com.tw'
          ]
        }
      ]
    }
  }
}
</script>
